import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { AutoLoginView } from '../component/autologin';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const SignInPage = lazy(() => import('src/pages/auth/sign-in'));
const SignUpPage = lazy(() => import('src/pages/auth/sign-up'));
const VerifyPage = lazy(() => import('src/pages/auth/verify'));
const ResetPassword = lazy(() => import('src/pages/auth/reset-password'));
const UpdatePassword = lazy(() => import('src/pages/auth/update-password'));

const auth = {
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <SignInPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'sign-up',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <SignUpPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'verify',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <VerifyPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'reset-password',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <ResetPassword />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'update-password',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <UpdatePassword />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'auto-login/:email/:token',
      element: (
        <AuthCenteredLayout>
          <AutoLoginView />
        </AuthCenteredLayout>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [auth],
  },
];
